import setFilters from 'store/reducer-utils/setFilters'
import { currencyMap } from 'utils/formatMoney'
import prepareChartData from 'utils/prepareChartData'
import { updateObject } from 'utils/updateObject'
import { IS_APP_PRODUCT_GETUNIQ } from 'utils/constants/product'
import {
  ACCOUNT_DROP_TABLE_DATA,
  ACCOUNT_FETCH_CHART_START,
  ACCOUNT_FETCH_FAIL,
  ACCOUNT_FETCH_TABLE_START,
  ACCOUNT_FILTERS_APPLY,
  ACCOUNT_SET_CHART,
  ACCOUNT_SET_FILTER,
  ACCOUNT_SET_TABLE,
  ACCOUNT_SETUP_CHART_CONFIG,
  SET_ACCOUNT_LOGIN,
  SET_CHART_TYPE,
  TOGGLE_METRIC_HIDDEN,
} from 'modules/Statistics/types'

const initialState = {
  login: null,
  table: {
    loadFailed: false,
    loading: false,
    data: [],
    summary: {},
    pagination: {
      total: 0,
    },
  },
  chart: {
    loadFailed: false,
    loading: false,
    data: [],
    summary: {},
    chartType: 'Line',
    measure: {
      impressions: '',
      clicks: '',
      revenue: IS_APP_PRODUCT_GETUNIQ ? currencyMap.rub : '',
      cost: IS_APP_PRODUCT_GETUNIQ ? currencyMap.rub : '',
    },
    metrics: [
      { id: 'clicks', isActive: true },
      { id: 'impressions', isActive: true },
      { id: 'cost', isActive: true },
      { id: 'revenue', isActive: true, isHidden: true },
    ],
  },
  filters: null,
}

const setLoading = (state, { payload }) =>
  updateObject(state, {
    [payload]: {
      ...state[payload],
      loading: true,
    },
  })

const setStatisticsChart = (state, { payload }) => {
  const { data, summary } = payload
  const preparedChartData = prepareChartData(data, summary)

  return updateObject(state, {
    chart: {
      ...state.chart,
      data: preparedChartData.items,
      summary: preparedChartData.summary,
      loading: false,
      loadFailed: false,
    },
  })
}

const setStatisticsAccountLogin = (state, { payload }) =>
  updateObject(state, {
    login: payload.login,
  })

const setStatisticsTable = (state, { payload }) =>
  updateObject(state, {
    table: {
      ...state.table,
      ...payload,
      data: [...state.table.data, ...payload.data],
      loading: false,
      loadFailed: false,
    },
  })

const fetchStatisticsFail = (state, { payload }) =>
  updateObject(state, {
    [payload]: {
      ...state[payload],
      loading: false,
      loadFailed: true,
    },
  })

const dropStatisticsTable = (state) =>
  updateObject(state, {
    table: {
      ...initialState.table,
    },
  })

const setStatisticsFilters = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const applyFilters = (state, { payload }) => updateObject(state, { filters: payload })

const toggleMetricHidden = (state, action) =>
  updateObject(state, {
    chart: {
      ...state.chart,
      metrics: [
        ...state.chart.metrics.map((metric) => {
          const { id, isHidden = false } = metric
          if (id === action.payload.id) {
            return { ...metric, isHidden: !isHidden }
          }
          return metric
        }),
      ],
    },
  })

const setChartType = (state, { payload }) =>
  updateObject(state, {
    chart: { ...state.chart, chartType: payload.type },
  })

const setupChartConfig = (state, { payload }) =>
  updateObject(state, {
    chart: { ...state.chart, ...payload },
  })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACCOUNT_FILTERS_APPLY:
      return applyFilters(state, action)
    case ACCOUNT_SET_FILTER:
      return setStatisticsFilters(state, action)
    case ACCOUNT_SET_CHART:
      return setStatisticsChart(state, action)
    case ACCOUNT_SET_TABLE:
      return setStatisticsTable(state, action)
    case ACCOUNT_FETCH_TABLE_START:
      return setLoading(state, action)
    case ACCOUNT_FETCH_CHART_START:
      return setLoading(state, action)
    case ACCOUNT_FETCH_FAIL:
      return fetchStatisticsFail(state, action)
    case ACCOUNT_DROP_TABLE_DATA:
      return dropStatisticsTable(state, action)
    case TOGGLE_METRIC_HIDDEN:
      return toggleMetricHidden(state, action)
    case SET_CHART_TYPE:
      return setChartType(state, action)
    case SET_ACCOUNT_LOGIN:
      return setStatisticsAccountLogin(state, action)
    case ACCOUNT_SETUP_CHART_CONFIG:
      return setupChartConfig(state, action)
    default:
      return state
  }
}

export default reducer
